<mat-dialog-content>
  <form [formGroup]="form">
    <EXP__glxy-wrap>
      <mat-form-field>
        <mat-select formControlName="sendTo">
          <mat-option [value]="'myself'">{{
            'CAMPAIGN_GENERIC.TEST_EMAIL.SEND_TEST_EMAIL_TO_MYSELF' | translate
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </EXP__glxy-wrap>
    <EXP__glxy-wrap>
      <email-preview-selector
        layout="vertical"
        [hydrationData]="hydrationData"
        (contactSelected)="updateSelectedContact($event)"
      ></email-preview-selector>
    </EXP__glxy-wrap>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close="">{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
  <button mat-button color="primary" (click)="sendPreviewEmail()">Send</button>
</mat-dialog-actions>
